// extracted by extract-css-chunks-webpack-plugin
module.exports = {"col":"col-3u4gcc0Q clearfix"};